// extracted by mini-css-extract-plugin
export const heroContainer = "hero-module--heroContainer--1jd8Q";
export const heroWrapper = "hero-module--heroWrapper--H3c1R";
export const textBox = "hero-module--textBox--25uZg";
export const greeting = "hero-module--greeting--78sdY";
export const typing = "hero-module--typing--3aBdy";
export const blinkCaret = "hero-module--blink-caret--2dm0T";
export const socialIcons = "hero-module--socialIcons--2Gs4l";